export default {"src":"/_next/static/media/sad-crying.94c6d1c9.svg","height":40,"width":40};